import React from "react";
import BulletPoints from "./BulletPoints/BulletPoints";
import ClientSuccessStory from "./ClientSuccessStory/ClientSuccessStory";

export const ServiceDelivery = ({
  settings,
  columns 
}) => {
  const bulletPoint = (columns || []).filter(
    (block) => block.settings?.layout === "bullet_points"
  );
  const clientSuccessStory = (columns || []).filter(
    (block) => block.settings?.layout === "client_success_story"
  );

  return (
    <div className={`flex flex-col lg:flex-row-reverse gap-8`}>
      {bulletPoint && <BulletPoints settings={settings} section={settings.section} columns={bulletPoint} />}
      {clientSuccessStory && <ClientSuccessStory settings={settings} section={settings.section} columns={clientSuccessStory} />}
    </div>
  );
};

export default ServiceDelivery;